import React from 'react';

import CliveChatMessage from '../Chat/CliveChatMessage';

import Button from '~/core/atoms/Buttons/Button';

interface CliveErrorMessageProps {
  message?: string;
  onRetry?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

const CliveErrorMessage: React.FC<CliveErrorMessageProps> = ({
  message = 'Something went wrong. Please try again.',
  onRetry,
  disabled = false,
  isLoading = false,
}) => {
  const messageContent = (
    <span className="flex flex-col items-start gap-20">
      <span className="text-red-600">{message}</span>
      <div className="flex items-center gap-12">
        {onRetry && (
          <Button
            className="text-md rounded-full bg-teal-600 px-20 text-white disabled:opacity-50"
            onClick={onRetry}
            disabled={disabled || isLoading}
          >
            {isLoading ? 'RETRYING...' : 'RETRY'}
          </Button>
        )}
      </div>
    </span>
  );

  return <CliveChatMessage message={messageContent} />;
};

export default CliveErrorMessage;
